import React from "react";
import { SUBSCRIBE_EMAIL_GQL } from "~/data/home";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { isValidEmail } from "~/utils/validators";
import Input from "../Input";
import Button from "../Button";

const CollectEmail = () => {
  const [mutationNewLetter] = useMutation(SUBSCRIBE_EMAIL_GQL);

  const formik = useFormik({
    initialValues: { email: "" },
    validate(values) {
      const errors: Record<string, string> = {};
      if (!values.email?.trim()) {
        errors.email = "Please enter your email address";
      } else if (!isValidEmail(values.email)) {
        errors.email = "Please enter a valid email address";
      }
      return errors;
    },
    onSubmit: async (values) => {
      return await mutationNewLetter({
        variables: {
          email: values?.email,
        },
        onCompleted() {
          toast.success("Subscribe successfully!");
          formik.resetForm();
        },
        onError(error, clientOptions) {
          toast.error(error.message);
        },
      });
    },
  });

  return (
    <div
      className="relative !mb-2 max-w-[562px] mx-auto border-none flex items-center justify-between gap-5 flex-wrap"
      id="email-form"
    >
      <Input
        className="flex-1 text-white"
        variant="transparent"
        type="email"
        placeholder="Enter your email"
        error={formik.errors.email}
        onKeyDown={(e) =>
          e.key === "Enter" && !formik?.isSubmitting && formik.submitForm()
        }
        // suffix={
        //   formik?.isSubmitting ? (
        //     <img
        //       src="/svgs/spinner8.svg"
        //       className="text-white animate-spin"
        //       width="14"
        //       height="14"
        //     />
        //   ) : (
        //     <button onClick={formik.submitForm}>
        //       <img
        //         src="/svgs/arrow-right2.svg"
        //         className="text-white"
        //         width="14"
        //         height="14"
        //       />{" "}
        //     </button>
        //   )
        // }
        {...formik.getFieldProps("email")}
        onBlur={() => formik.setFieldError("email", "")}
      />
      <Button
        variant="primary"
        onClick={formik.submitForm}
        disabled={formik?.isSubmitting}
      >
        Subscribe
      </Button>
    </div>
  );
};

export default CollectEmail;
